"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HitProvider = exports.useHit = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useClock = require("../Clock/useClock");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var HitContext = /*#__PURE__*/_react["default"].createContext();
var HitProvider = function HitProvider(_ref) {
  var children = _ref.children,
    isProductPageHit = _ref.isProductPageHit;
  var _timeBetweenStartAndE = (0, _useClock.timeBetweenStartAndEnd)(),
    isTimeBetweenStartAndEnd = _timeBetweenStartAndE.isTimeBetweenStartAndEnd;
  var _useState = (0, _react.useState)(null),
    hitProduct = _useState[0],
    setHitProduct = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    sale = _useState2[0],
    setSale = _useState2[1];
  var _useState3 = (0, _react.useState)(isTimeBetweenStartAndEnd),
    isActive = _useState3[0],
    setIsActive = _useState3[1];
  return __jsx(HitContext.Provider, {
    value: {
      isActive: isActive,
      setIsActive: setIsActive,
      hitProduct: hitProduct,
      setHitProduct: setHitProduct,
      sale: sale,
      isProductPageHit: isProductPageHit,
      setSale: setSale
    }
  }, children);
};
exports.HitProvider = HitProvider;
var useHit = function useHit() {
  var isProductPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (isProductPage) {
    return {
      hitProduct: null,
      sale: null
    };
  }
  var context = (0, _react.useContext)(HitContext);
  if (!context) {
    throw new Error("useHit must be used within a HitProvider");
  }
  return context;
};
exports.useHit = useHit;